import { gql } from '@apollo/client/core';

export const WEBHOOK_DELIVERY_ATTEMPT_FIELDS = gql`
  fragment WebhookDeliveryAttemptFields on WebhookDeliveryAttempt {
    id
    attempt
    attemptedAt
    durationMs
    topic
    recordId
    responseStatus
    failureKind
  }
`;
